import { http } from '@shared/api/http-client';
import type { DashboardStats } from '@features/analytics/model/dashboard.types';

export const dashboardApi = {
  stats(): Promise<DashboardStats> {
    return http.get<DashboardStats>('/budgeting/analytics/dashboard');
  },
};
